module.exports = __webpack_public_path__ + "static/img/c1.61c1454.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/cloud/c1.png
// module id = NS63
// module chunks = 0